import { render, staticRenderFns } from "./BoneAdd.vue?vue&type=template&id=f4e9c2fe&scoped=true"
import script from "./BoneAdd.vue?vue&type=script&lang=js"
export * from "./BoneAdd.vue?vue&type=script&lang=js"
import style0 from "./BoneAdd.vue?vue&type=style&index=0&id=f4e9c2fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e9c2fe",
  null
  
)

export default component.exports